async function validarRelacionamentoOtica(laboratorio, otica) {
  const requestOptions = {
    method: "GET",
    headers: {
      access_token: sessionStorage.getItem("token"),
      client_id: localStorage.getItem("clientid"),
      otica: otica,
      laboratorio: laboratorio,
    },
  };

  try {
    const response = await fetch(
      process.env.REACT_APP_ESSILOR_API + "gestao-laboratorios/v1/relacionamento",
      requestOptions,
    );
    const json = await response.json();
    return {
      ok: json && json.relacionamento === true,
      mensagem: (json && json[0] && json[0].mensagem) || null,
      status: response.status,
    };
  } catch {
    return { ok: false, mensagem: null, status: 0 };
  }
}

export { validarRelacionamentoOtica };
